/* eslint-disable react-hooks/set-state-in-effect */
import { useCallback, useEffect, useState } from 'react'
import { kanbify } from '../lib/kanbifyClient'

/* ========== CARD DEPENDENCIES (BLOCKERS) ========== */
export function useDependencies(cardId) {
    const [dependencies, setDependencies] = useState([])

    const fetch = useCallback(async () => {
        if (!cardId) return

        // Fetch where card is blocking others (source = cardId)
        const { data: blocks } = await kanbify
            .from('card_links')
            .select('id, link_type, target_card_id, target_card:cards!card_links_target_card_id_fkey(id, title, is_completed)')
            .eq('source_card_id', cardId)

        // Fetch where card is blocked by others (target = cardId)
        const { data: isBlockedBy } = await kanbify
            .from('card_links')
            .select('id, link_type, source_card_id, source_card:cards!card_links_source_card_id_fkey(id, title, is_completed)')
            .eq('target_card_id', cardId)

        const all = [
            ...(blocks || []).map(d => ({ id: d.id, direction: 'blocks', type: d.link_type, linked_card: d.target_card })),
            ...(isBlockedBy || []).map(d => ({ id: d.id, direction: 'is_blocked_by', type: d.link_type, linked_card: d.source_card }))
        ]
        setDependencies(all)
    }, [cardId])

    useEffect(() => { fetch() }, [fetch])

    const addDependency = async (type, targetCardId) => {
        // If type is 'is_blocked_by', we actually want to insert source = targetCardId, target = cardId, type = 'blocks'
        // But for simplicity of our UI, let's just insert 'blocks' or 'is blocked by' straight up.
        const { error } = await kanbify.from('card_links')
            .insert([{ source_card_id: cardId, target_card_id: targetCardId, link_type: type }])
        if (!error) await fetch()
        return { error }
    }

    const removeDependency = async (id) => {
        const { error } = await kanbify.from('card_links').delete().eq('id', id)
        if (!error) setDependencies(p => p.filter(d => d.id !== id))
    }

    return { dependencies, fetch, addDependency, removeDependency }
}
